import axios, { AxiosRequestConfig, AxiosRequestHeaders } from "axios";
import env from "config";

const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
  env: env.identifier,
};

interface ServiceConfig {
  controller: string;
  headers?: HeadersInit;
}

interface AxiosRequest {
  uri?: string;
  params?: AxiosRequestConfig;
  headers?: AxiosRequestHeaders;
}

export class BaseRESTService {
  private axios = axios.create({
    baseURL: env.server_url,
  });

  constructor(private config: ServiceConfig) {}

  async get(request: AxiosRequest = {}): Promise<any> {
    try {
      const url = `${this.config.controller}/${request.uri ?? ""}`;

      const config = {
        params: request.params,
        headers: {
          ...DEFAULT_HEADERS,
          ...request.headers,
        },
      };

      return this.axios
        .get(url, config)
        .then((result) => {
          return result.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    } catch (e) {
      console.error(e);
      return;
    }
  }

  async delete(request: AxiosRequest = {}): Promise<any> {
    try {
      const url = `${this.config.controller}/${request.uri ?? ""}`;

      const config = {
        params: {
          ...request.params,
        },
        headers: {
          ...DEFAULT_HEADERS,
          ...request.headers,
        },
      };

      return this.axios
        .delete(url, config)
        .then((result) => {
          return result.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    } catch (e) {
      console.error(e);
      return;
    }
  }

  async post(
    request: AxiosRequest = {},
    data: any,
    onProgress?: (event: ProgressEvent) => void
  ): Promise<any> {
    try {
      const url = `${this.config.controller}/${request.uri ?? ""}`;
      const config = {
        params: request.params,
        headers: {
          ...DEFAULT_HEADERS,
          ...request.headers,
        },
        onUploadProgress: (ev: ProgressEvent) => {
          if (onProgress) {
            onProgress(ev);
          }
        },
      } as any;

      return this.axios
        .post(url, data, config)
        .then((result) => {
          return result.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    } catch (e) {
      console.error(e);
      return;
    }
  }

  async put(request: AxiosRequest = {}, data: any): Promise<any> {
    try {
      const url = `${this.config.controller}/${request.uri ?? ""}`;
      const config = {
        params: request.params,
        headers: {
          ...DEFAULT_HEADERS,
          ...request.headers,
        },
      };

      return this.axios
        .put(url, data, config)
        .then((result) => {
          return result.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    } catch (e) {
      console.error(e);
      return;
    }
  }

  async patch(request: AxiosRequest = {}, data: any): Promise<any> {
    try {
      const url = `${this.config.controller}/${request.uri ?? ""}`;
      const config = {
        params: request.params,
        headers: {
          ...DEFAULT_HEADERS,
          ...request.headers,
        },
      };

      return this.axios
        .patch(url, data, config)
        .then((result) => {
          return result.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    } catch (e) {
      console.error(e);
      return;
    }
  }
}
